import axios from 'axios';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

// Define the API endpoint
const API_URL = 'https://api.example.com/puzzles';

// Async thunk for fetching puzzles
export const fetchPuzzles = createAsyncThunk('puzzles/fetchPuzzles', async () => {
    // Mock API call
    await new Promise(resolve => setTimeout(resolve, 500));
    return [
        { id: '1', title: 'Crossword #1', description: 'A simple crossword puzzle for beginners.', difficulty: 1 },
        { id: '2', title: 'Sudoku Challenge', description: 'Hard difficulty sudoku.', difficulty: 3 },
        { id: '3', title: 'Logic Grid', description: 'Solve the mystery.', difficulty: 2 },
    ];
    // const response = await axios.get(API_URL);
    // return response.data;
});

// Async thunk for saving a puzzle
export interface Puzzle {
    id: string;
    title: string;
    description?: string;
    difficulty?: number;
}

export const savePuzzle = createAsyncThunk('puzzles/savePuzzle', async (puzzle: Puzzle) => {
    // Mock API call
    await new Promise(resolve => setTimeout(resolve, 500));
    return puzzle;
    // const response = await axios.post(API_URL, puzzle);
    // return response.data;
});

// Create a slice for puzzles
const puzzlesSlice = createSlice({
    name: 'puzzles',
    initialState: {
        puzzles: [] as Puzzle[],
        loading: false,
        error: null as string | null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPuzzles.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchPuzzles.fulfilled, (state, action: PayloadAction<Puzzle[]>) => {
                state.loading = false;
                state.puzzles = action.payload;
            })
            .addCase(fetchPuzzles.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message ?? null;
            })
            .addCase(savePuzzle.fulfilled, (state, action: PayloadAction<Puzzle>) => {
                state.puzzles.push(action.payload);
            });
    },
});

// Export the reducer
export default puzzlesSlice.reducer;